import { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useUserDetails } from 'api/useUserDetails';
import { Profile } from 'design-system/AcSidebar/constants';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';
import { useTabTracking } from 'hooks/useTabTracking';

import PageTopBar from 'components/Topbar/PageTopBar';
import { Spinner } from 'components/ui/spinner';

import './style.scss';

enum EProfileState {
  PERSONAL = 'personal',
  PASSWORD = 'password'
}

const ProfileView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname.split('/')[4];
  const [tab, setTab] = useState(currentTab);
  const { isLoading } = useUserDetails();

  useEffect(() => {
    setTab(location.pathname.split('/').pop() || '');
  }, []);

  const tabs = [
    { label: 'Personal Info', value: EProfileState.PERSONAL },
    { label: 'Password', value: EProfileState.PASSWORD }
  ];

  const { handleTabChangeWithEvent } = useTabTracking({
    sidebarTab: Profile.title,
    tabs,
    customNavigate: (newValue) => {
      setTab(newValue);
      const newPath = `/profile/${newValue}`;
      navigate(newPath);
    }
  });

  if (isLoading)
    return <Spinner className="absolute top-1/2 left-1/2 size-16" />;

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Profile" />}
      handleTabChange={handleTabChangeWithEvent}
      activeTabVal={tab}
    />
  );
};

export default ProfileView;
